import { render, staticRenderFns } from "./LlAvatar.vue?vue&type=template&id=0101cf20&scoped=true"
import script from "./LlAvatar.vue?vue&type=script&lang=js"
export * from "./LlAvatar.vue?vue&type=script&lang=js"
import style0 from "./LlAvatar.vue?vue&type=style&index=0&id=0101cf20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0101cf20",
  null
  
)

export default component.exports